import axios from '../../../libs/axios'
import {AuthModel, UserModel} from './_models'

// export const GET_USER_BY_ACCESSTOKEN_URL = `${API_URL}/verify_token`
export const LOGIN_URL = `cms/auth/login`
export const REGISTER_URL = `cms/auth/register`
export const REQUEST_PASSWORD_URL = `cms/auth/forgot_password`
export const RESET_PASSWORD_URL = `cms/auth/reset_password`
export const VERIFY_EMAIL_URL = `cms/auth/verify-email`
export const RESEND_VERIFICATION_URL = `cms/auth/resend-verification`

// Server should return AuthModel
export function login(username: string, password: string) {
  return axios.post<AuthModel>(LOGIN_URL, {
    username,
    password,
  })
}

// Server should return AuthModel
export function register(values: any) {
  return axios.post(REGISTER_URL, {
    email: values.email,
    username: values.username,
    institution_name: values.institution_name,
    institution_category: values.institution_category,
    country: values.country,
    password: values.password,
    registration_source: values.registration_source,
    gender: values.gender
  })
}

// Server should return object => { result: boolean } (Is Email in DB)
export function requestPassword(email: string) {
  return axios.post<{result: boolean}>(REQUEST_PASSWORD_URL, {
    email,
  })
}

export function resetPassword(token: string, password: string) {
  return axios.post(RESET_PASSWORD_URL, {
    token,
    password,
  })
}

// export function getUserByToken(token: string) {
//   return axios.post<UserModel>(GET_USER_BY_ACCESSTOKEN_URL, {
//     api_token: token,
//   })
// }

export function getUserProfile(token: string) {
  return axios.get<{user: UserModel; permissions: any[]}>(`cms/auth/profile`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
}

export function getSidebarMenus(axiosPrivate) {
  return axiosPrivate.get(`dashboard/menus`)
}

export function getInstitutionSuggestions(field: string, query: string) {
  return axios.get<{suggestions: string[]}>(`cms/auth/registration/institution-suggestions`, {
    params: {field, query},
  })
}

export function verifyEmail(token: string) {
  return axios.get(VERIFY_EMAIL_URL, {
    params: {token},
  })
}

export function resendVerification(email: string) {
  return axios.post(RESEND_VERIFICATION_URL, {
    email,
  })
}
